module.exports = __webpack_public_path__ + "static/media/rotate.0cf58d4f.gif";